import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const InlineErrorDisplay = ({ 
  errorMessage, 
  errorField, 
  errorParameter, 
  ruleName, 
  ruleType, 
  executionOrder 
}) => {
  return (
    <Alert variant="danger" className="mb-3">
      <Alert.Heading as="h6" className="mb-2">
        Step {executionOrder}: {ruleName} ({ruleType})
      </Alert.Heading>

      <div className="mb-2">
        {errorField && (
          <span className="badge bg-danger me-2">
            Field: {errorField}
          </span>
        )}
        {errorParameter && (
          <span className="badge bg-warning text-dark me-2">
            Config: {errorParameter}
          </span>
        )}
      </div>

      <p className="mb-0" style={{ fontSize: '0.9em', whiteSpace: 'pre-wrap' }}>
        {errorMessage}
      </p>
    </Alert>
  );
};

InlineErrorDisplay.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  errorField: PropTypes.string,
  errorParameter: PropTypes.string,
  ruleName: PropTypes.string.isRequired,
  ruleType: PropTypes.string.isRequired,
  executionOrder: PropTypes.number.isRequired,
};

export default InlineErrorDisplay;
